import { LocalStorageKeyType } from 'models';

// eslint-disable-next-line no-redeclare
export function getFromLocalStorage(k: LocalStorageKeyType): string;
// eslint-disable-next-line no-redeclare
export function getFromLocalStorage(key: LocalStorageKeyType) {
	const res = localStorage.getItem(key as string);
	return res ? JSON.parse(res) : res;
}
